import React from 'react';

const SmallItalic = ({ className, ...rest }) => {
  return <span className={ `uk-text-italic ${ className }` } { ...rest } />;
};

export default SmallItalic;
